export default __webpack_public_path__ + "static/media/protectora.31d5331b.png";